export const DetailBlocks = ({ heading, image, data, className }) => (
  <div
    className={`sm:lil-p-4 lil-border-dashed lil-border-grey-350 lil-py-10 ${className}`}
  >
    <div className="lil-flex lil-justify-center">
      <img src={image} alt="lock" />
      <p className="lil-text-base sm:lil-text-s-12 lil-pl-2">{heading}</p>
    </div>
    <div className="lil-items-center lil-text-center lil-pt-2 lil-text-s-20 sm:lil-text-base lil-font-semibold sm:lil-pt-1">
      {data}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/fundOverview/detailBlocks.tsx